import { render, staticRenderFns } from "./TimeSinceDisplay.vue?vue&type=template&id=9e5e3836&"
import script from "./TimeSinceDisplay.vue?vue&type=script&lang=ts&"
export * from "./TimeSinceDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports